import { PageSizeEnum } from '../../../../api/shared/enums/page-size.enum';
import { UserAppPreferenceChartColors } from '../../models/user-app-preferences-chart-colors.model';
import { UserAppPreferenceMonitoringCommonFilters } from '../../models/user-app-preferences-filters.model';
import {
    UserAppPreferencesVersion,
    UserAppMonitorPreferencesModel,
    UserAppTargetingPreferencesModel,
    UserAppPreferencesModel
} from '../../models/user-app-preferences.model';

export interface OnePointOh {
    version: UserAppPreferencesVersion;
    monitoringPrefs: UserAppMonitorPreferencesModel
    & {
        reportsPrefs: {
            defaultFilters: UserAppPreferenceMonitoringCommonFilters;
            defaultChartColors: UserAppPreferenceChartColors;
        };
    };
    targetingPrefs: UserAppTargetingPreferencesModel;
};

/**
     * Simply adding versioning to all future UserPreferences
     */
export function fromNoVersionToOnePointOh(oldDataModel: UserAppPreferencesModel): UserAppPreferencesModel {
    oldDataModel.version = '1.0';

    // Some old versions use 200 as their display size value for Discover page sizes instead of 250
    const savedSearchesDisplaySettings = oldDataModel.targetingPrefs.savedSearchesPrefs.defaultDisplaySettings;
    if (Number(savedSearchesDisplaySettings.pageSize) === PageSizeEnum.twoHundred) {
        savedSearchesDisplaySettings.pageSize = PageSizeEnum.twoFifty;
    }
    const listsDisplaySettings = oldDataModel.targetingPrefs.targetedListsPrefs.defaultDisplaySettings;
    if (Number(listsDisplaySettings.pageSize) === PageSizeEnum.twoHundred) {
        listsDisplaySettings.pageSize = PageSizeEnum.twoFifty;
    }
    return oldDataModel;
}
